<template lang="html">
  <div id="section-slides" class="">
    <swiper :options="sliderOptions" ref="buildingSlider">
      <!-- Each slide -->
      <swiper-slide v-for="slide in slides" :key="slide.id">
        <div class="slide position-relative">
          <!-- Overlay -->
          <div class="overlay"></div>

          <!-- Slide image -->
          <div v-if="slide.isPano" class="tour-pano"
          :class="['tour-pano-' + slide.id]" />
          <img v-else :src="slide.src" />

        </div>
      </swiper-slide>


    </swiper>
    <!-- Caption -->
    <div class="caption-container">
      <div class="caption mt-2" v-html="currentCaption"></div>
    </div>
    <!-- Navigation -->
    <div class="arrows d-inline-block">
      <div v-show="prevLabel"
      class="button-prev nav-button px-4" slot="button-prev">
        <i class="fal fa-long-arrow-left"></i>
      </div>
      <div v-show="nextLabel"
      class="button-next nav-button px-4" slot="button-next">
        <i class="fal fa-long-arrow-right"></i>
      </div>
      <div class="clear"></div>
    </div>

  </div>
</template>

<script>
/* global pannellum */
export default {
  name: 'section-slides',
  props: {
    slides: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      pano: null,
      loadedPanos: [],
      curSlide: 0,
      sliderOptions: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        centeredSlides: true,
        loop: false,
        speed: 750,
        noSwipingClass: 'swiper-no-swiping',
        keyboardZoom: false,
        mouseZoom: false,
        navigation: {
          prevEl: '.button-prev',
          nextEl: '.button-next'
        }
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.buildingSlider.swiper;
    },
    prevLabel() {
      if (this.slides && this.curSlide - 1 >= 0) {
        return this.slides[this.curSlide - 1].caption;
      }
      return '';
    },
    nextLabel() {
      if (this.slides && this.curSlide + 1 < this.slides.length) {
        return this.slides[this.curSlide + 1].caption;
      }
      return '';
    },
    currentCaption() {
      if (this.slides[this.curSlide].caption) {
        return this.slides[this.curSlide].caption;
      }
      return '';
    }
  },
  methods: {
    setSlide(index) {
      this.swiper.slideTo(index, 500, false);
      this.loadPano(index);
    },
    loadPano(index) {
      if (this.slides[index].isPano && !this.loadedPanos.includes(index)) {
        const el = document.getElementsByClassName(`tour-pano-${index}`)[0];
        this.pano = pannellum.viewer(el, {
          type: 'equirectangular',
          panorama: this.slides[index].src,
          autoLoad: true,
          showZoomCtrl: false,
          showControls: false,
          showFullscreenCtrl: false,
          mouseZoom: false,
          keyboardZoom: false,
          autoRotate: 2,
          autoRotateInactivityDelay: 4000,
          minHfov: 100,
          maxHfov: 100
        });
        this.loadedPanos.push(index);
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.swiper.on('slideChange', () => {
        const index = this.swiper.activeIndex;
        this.curSlide = index;
        this.loadPano(index);
      });
    }, 1000, this);
  }
};
</script>

<style lang="scss">
#section-slides {
  width: 100%;
  height: calc(100% - #{$app-bar-height});
  background-color: var(--background);
  position: relative;

  .caption-container {
    position: absolute;
    transform: rotate(270deg);
    left: calc(50% - 40px);
    top: 50%;
    padding-left: $app-bar-height;

    z-index: 100;
    width: 100%;
    background-color: var(--background);

    .caption {
      font-family: Didot-Regular, sans-serif;
      color: var(--branding);
      font-size: 4rem;
      padding: 0.25rem 0;
      letter-spacing: 1px;
      width: 100%;
      z-index: 15;

      text-transform: uppercase;
    }
  }

  .button-prev,
  .button-next {
    top: auto;
    bottom: 0;
    text-align: center;

    &:active {
      transform: scale(0.95);
      i {
        color: rgba(0, 0, 0, 0.55);
      }
    }
  }

  .button-prev {
    right: 76px !important;
    left: auto !important;

    @media screen and (min-width: $breakpoint-md) {
      // left: 10px;
    }

    .fal {
      // left: 0;
    }

    &:hover {
      .fal {
        // left: -10px;
      }
    }
  }

  .button-next {
    right: 0px !important;
    left: auto !important;

    @media screen and (min-width: $breakpoint-md) {
      // right: 10px;
    }

    .fal {
      // right: 0;
    }

    &:hover {
      .fal {
        // right: -10px;
      }
    }
  }

  .nav-button {
    font-family: Scandia-Regular, sans-serif;
    display: flex;
    align-items: center;
    // position: absolute;
    display: inline-block;
    background-color: white;
    color: var(--branding);
    outline: none;
    padding: 20px 24px;
    z-index: 101;

    @media screen and (min-width: $breakpoint-md) {
      font-size: 1rem;
    }

    .fal {
      font-size: 2.0rem;
      position: relative;
      transition: 0.1s;
    }
  }

  .swiper-wrapper {
    align-items: center;
    height: 100%;
  }


  .swiper-container {
    width: 100%;
    height: 100%;


  }

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 95%;

    @media screen and (min-width: $breakpoint-md) {
      width: 90%;
    }

    &.swiper-slide-prev .slide { transform: scale(0.8) translateX(20%); }
    &.swiper-slide-next .slide { transform: scale(0.8) translateX(-20%); }

    &.swiper-slide-active {
      z-index: 1;
      .slide {
        transform: scale(1);

        .overlay {
          display: none;
        }
      }
    }
  }

  .slide {
    display: inline-block;
    width: 95%;
    transition: all 0.75s ease-out;
    max-height: 95vh;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    @media screen and (min-width: $breakpoint-md) {
      width: 90%;
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      // background-color: rgba(0, 0, 0, 0.65);
      z-index: 1;
    }

    img {
      max-width: 100%;
      max-height: 80vh;
      height: auto;
    }

    .tour-pano {
      max-width: 100%;
      max-height: 80vh;
      height: 1000px;
    }


  }

  .pnlm-container {
    background: transparent;
  }

  .pnlm-load-box {
    font-family: Scandia-Regular, sans-serif;
    font-size: 1rem;

    .pnlm-lbox {
      display: none;
    }

    .pnlm-msg {
    }
  }

  .arrows {
    position: absolute;
    right: 0;
    bottom: 0;
    -webkit-box-shadow: -1px -1px 6px 5px rgba(0, 0, 0, 0.25);
    -moz-box-shadow: -1px -1px 6px 5px rgba(0, 0, 0, 0.25);
    box-shadow: -1px -1px 6px 5px rgba(0, 0, 0, 0.25);

    z-index: 999;

    .clear {
      clear: both;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SectionSlides.vue